import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { BaseView } from 'src/app/submodules/angular-ui-common/base-view';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { BehaviorSubject, from, interval, of, timer } from 'rxjs';
import { concatMap, delay, repeat, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent extends BaseView {

  @ViewChild('teamCarousel') teamCarousel: ElementRef;

  //src$ 

  i = 0;
  images = ['assets/images/team2.jpeg','assets/images/team3.jpeg'];

  constructor(protected _injector: Injector, public deviceDetectorService: DeviceDetectorService) {
    super(_injector)
  }


  ngAfterViewInit(): void {


    setInterval(() => {
      this.teamCarousel.nativeElement.src = this.images[this.i]
      if(this.i<this.images.length-1) 
        this.i++ 
      else 
        this.i = 0;
    }, 5000);
  
    
  //   this.src$ = of('assets/images/team1.jpeg','assets/images/team2.jpeg').pipe(
  //     concatMap(url => of(url).pipe(delay(3000))),
  //     repeat()
  //  );
  }

  public contactUsClick(){
    this._injector.get(Router).navigate(['/home'],{ fragment: 'form' })
  }

 

}
